<script>
import IconSvg from '@/components/IconSvg/index.vue'

export default {
  name: 'MenuItem',
  functional: true,
  components: {
    IconSvg
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    hasIcon: {
      type: Boolean,
      default: false
    }
  },
  render(h, context) {
    const { hasIcon, icon, title } = context.props
    const vnodes = []

    if (hasIcon && icon) {
      if (icon.includes('el-icon')) {
        vnodes.push(<i class={[icon, 'sub-el-icon']} />)
      } else {
        // vnodes.push(<em class={`lsb-icon-${icon}`}></em>)

        // vnodes.push(
        //   <IconSvg
        //     class={'menu__sidebar-icon '}
        //     icon={`sidebar_bar_chart_icon`}
        //     has-fill
        //   />
        // )
        vnodes.push(
          <IconSvg
            class={'menu__sidebar-icon '}
            icon={`sidebar_${icon}_icon`}
            has-fill
          />
        )
      }
    }

    if (title) {
      // eslint-disable-next-line jsx-quotes
      vnodes.push(<span slot="title">{title}</span>)
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
</style>
